import { RandomGenerator } from '@grandom/core';
import { getRest } from '../utils';
import ExcludeFilter from './ExcludeFilter';
export default class RandomStringShuffle extends RandomGenerator {
    constructor(engine) {
        super(engine);
        this.shuffle = this.shuffle.bind(this);
    }
    // -----------------------------------------------------------------------------------------------
    canBeParsed(arg1) {
        return typeof arg1 === 'string';
    }
    parse(arg1, arg2, arg3) {
        if (arg1.length < 1) {
            return '';
        }
        const { count, options } = getRest(arg1, arg2, arg3);
        // -------------------------------------------------------------------------
        const exclude = 'exclude' in options
            ? new ExcludeFilter(options.exclude)
            : undefined;
        const filter = typeof options.filter === 'function'
            ? options.filter
            : undefined;
        // -------------------------------------------------------------------------
        const characters = [...arg1];
        const pool = [];
        let length = count === -1
            ? characters.length
            : count;
        // clamp length, disallow larger count, than the input string
        if (length > characters.length) {
            length = characters.length;
        }
        // preshuffle, to allow all characters to be picked from, if count
        // is smaller, than the input string length
        this._engine.shuffleArray(characters);
        for (let i = 0; i < length; i++) {
            const character = characters[i];
            if (exclude?.matches(character) === true) {
                continue;
            }
            if (filter?.(character) === false) {
                continue;
            }
            pool.push(character);
        }
        return pool.join('');
    }
    // -----------------------------------------------------------------------------------------------
    shuffle(arg1, arg2, arg3) {
        if (this.canBeParsed(arg1)) {
            return this.parse(arg1, arg2, arg3);
        }
        throw new TypeError(
        // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
        `Must be called with a string, got: ${arg1} (typeof === '${typeof arg1}').`);
    }
}
//# sourceMappingURL=index.js.map